import React from 'react'
import { Link } from 'react-router-dom'

// The two halves of Roles & Responsibilities: what each role is for, and where to click.
// Both pages carry these tabs so either one is a click away from the other.
const TABS = [
  { to: '/roles', label: 'Who does what' },
  { to: '/roles/guide', label: 'Step-by-step guide' },
]

export default function HelpTabs({ active, isDark, showGuide = true }) {
  return (
    <nav aria-label="Roles & Responsibilities" className={`flex gap-1 border-b ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
      {TABS.filter(t => showGuide || t.to !== '/roles/guide').map(t => {
        const on = t.to === active
        return (
          <Link
            key={t.to}
            to={t.to}
            aria-current={on ? 'page' : undefined}
            className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${on
              ? (isDark ? 'border-blue-400 text-blue-300' : 'border-blue-600 text-blue-700')
              : (isDark ? 'border-transparent text-gray-400 hover:text-gray-200' : 'border-transparent text-gray-500 hover:text-gray-800')}`}
          >
            {t.label}
          </Link>
        )
      })}
    </nav>
  )
}
